var FcChoiceDialogModule = /** @class */ (function () {
    function FcChoiceDialogModule() {
    }
    return FcChoiceDialogModule;
}());
export { FcChoiceDialogModule };
